import type React from 'react';
import MarkFeatureCard from './mark-feature-card';
import Icons from 'assets/icons';

import { Box } from 'ui/box';
import { Stack } from 'ui/stack';

const FEATURE_CARDS = [
  {
    icon: Icons.LineGraph,
    title: 'Track Critical Elements',
    description:
      'Track year-over-year shifts in deposits, applicants, and yield at a glance.',
  },
  {
    icon: Icons.ChartsVerticalBar,
    title: 'Benchmark against the market',
    description:
      'See how your volume builds, rates, and proportions compare to peer and regional cohorts across any student segment.',
  },
  {
    icon: Icons.Funnel,
    title: 'Analyze funnel performance',
    description:
      'Track inquiry conversion, uncover drop-off points, and catch melt before it grows.',
  },
  {
    icon: Icons.Profile2,
    title: 'Report to stakeholders',
    description:
      'Surface the right numbers at the right time — ready to share.',
  },
];

const MarkWalkthroughStep1 = (): React.JSX.Element => (
  <Stack sx={{ flex: '1 1 0%', alignItems: 'center', gap: 2, pt: 2 }}>
    <Icons.MarkLogo className="size-20" role="img" aria-label="MARK" />

    <Stack sx={{ alignItems: 'center', gap: 0.5, textAlign: 'center' }}>
      <h2 className="text-2xl font-bold text-navy-800">
        Meet MARK - Your on-demand analyst.
      </h2>
      <p className="text-base text-gray-700">
        Ask MARK your data questions and it keeps you informed on the metrics
        that matter most to your success.
      </p>
    </Stack>

    <Box
      sx={{
        display: 'grid',
        width: '100%',
        gridTemplateColumns: 'repeat(1, minmax(0, 1fr))',
        gap: 2,
        '@media (min-width: 780px)': {
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        },
      }}
    >
      {FEATURE_CARDS.map((card) => (
        <MarkFeatureCard
          key={card.title}
          icon={card.icon}
          title={card.title}
          description={card.description}
          sx={{ minHeight: '142px' }}
        />
      ))}
    </Box>
  </Stack>
);

export default MarkWalkthroughStep1;
